// Translated
// Migrated
<template>
  <div>
    <CategoryTripCardWide
      class="max-sm:hidden"
      :trip="trip"
    />
    <TripCard
      class="sm:hidden !shadow-none"
      :trip="trip"
    />
  </div>
</template>

<script>
export default defineNuxtComponent({
  props: {
    trip: {
      type: Object,
      default: null,
    },
  },
})
</script>
